import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Ti\u1EBFng Vi\u1EC7t",
  code: "vi",
  messages: {
    alert: {
      close: "\u0110\xF3ng"
    },
    authForm: {
      hidePassword: "\u1EA8n m\u1EADt kh\u1EA9u",
      showPassword: "Hi\u1EC3n th\u1ECB m\u1EADt kh\u1EA9u",
      submit: "Ti\u1EBFp t\u1EE5c"
    },
    banner: {
      close: "\u0110\xF3ng"
    },
    calendar: {
      nextMonth: "Th\xE1ng sau",
      nextYear: "N\u0103m sau",
      prevMonth: "Th\xE1ng tr\u01B0\u1EDBc",
      prevYear: "N\u0103m tr\u01B0\u1EDBc"
    },
    carousel: {
      dots: "Ch\u1ECDn slide \u0111\u1EC3 hi\u1EC3n th\u1ECB",
      goto: "\u0110i t\u1EDBi \xF4 {slide}",
      next: "Sau",
      prev: "Tr\u01B0\u1EDBc"
    },
    chatPrompt: {
      placeholder: "Nh\u1EADp tin nh\u1EAFn c\u1EE7a b\u1EA1n \u1EDF \u0111\xE2y..."
    },
    chatPromptSubmit: {
      label: "G\u1EEDi"
    },
    colorMode: {
      dark: "T\u1ED1i",
      light: "S\xE1ng",
      switchToDark: "Chuy\u1EC3n sang ch\u1EBF \u0111\u1ED9 t\u1ED1i",
      switchToLight: "Chuy\u1EC3n sang ch\u1EBF \u0111\u1ED9 s\xE1ng",
      system: "H\u1EC7 th\u1ED1ng"
    },
    commandPalette: {
      back: "Quay l\u1EA1i",
      close: "\u0110\xF3ng",
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u",
      noMatch: "Kh\xF4ng c\xF3 k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p",
      placeholder: "Nh\u1EADp l\u1EC7nh ho\u1EB7c t\xECm ki\u1EBFm..."
    },
    contentSearch: {
      links: "Li\xEAn k\u1EBFt",
      theme: "Ch\u1EE7 \u0111\u1EC1"
    },
    contentSearchButton: {
      label: "T\xECm ki\u1EBFm..."
    },
    contentToc: {
      title: "Trong trang n\xE0y"
    },
    dashboardSearch: {
      theme: "Ch\u1EE7 \u0111\u1EC1"
    },
    dashboardSearchButton: {
      label: "T\xECm ki\u1EBFm..."
    },
    dashboardSidebarCollapse: {
      collapse: "Thu g\u1ECDn thanh b\xEAn",
      expand: "M\u1EDF r\u1ED9ng thanh b\xEAn"
    },
    dashboardSidebarToggle: {
      close: "\u0110\xF3ng thanh b\xEAn",
      open: "M\u1EDF thanh b\xEAn"
    },
    error: {
      clear: "Quay l\u1EA1i trang ch\u1EE7"
    },
    fileUpload: {
      removeFile: "X\xF3a {filename}"
    },
    header: {
      close: "\u0110\xF3ng menu",
      open: "M\u1EDF menu"
    },
    inputMenu: {
      create: 'T\u1EA1o "{label}"',
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u",
      noMatch: "Kh\xF4ng c\xF3 k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p"
    },
    inputNumber: {
      decrement: "Gi\u1EA3m",
      increment: "T\u0103ng"
    },
    modal: {
      close: "\u0110\xF3ng"
    },
    pricingTable: {
      caption: "So s\xE1nh c\xE1c k\u1EBF ho\u1EA1ch gi\xE1"
    },
    prose: {
      codeCollapse: {
        closeText: "Thu g\u1ECDn",
        name: "m\xE3",
        openText: "M\u1EDF r\u1ED9ng"
      },
      collapsible: {
        closeText: "\u1EA8n",
        name: "thu\u1ED9c t\xEDnh",
        openText: "Hi\u1EC3n th\u1ECB"
      },
      pre: {
        copy: "Sao ch\xE9p m\xE3 v\xE0o b\u1ED9 nh\u1EDB t\u1EA1m"
      }
    },
    selectMenu: {
      create: 'T\u1EA1o "{label}"',
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u",
      noMatch: "Kh\xF4ng c\xF3 k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p",
      search: "T\xECm ki\u1EBFm..."
    },
    slideover: {
      close: "\u0110\xF3ng"
    },
    table: {
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u"
    },
    toast: {
      close: "\u0110\xF3ng"
    }
  }
});
